module.exports = __webpack_public_path__ + "static/media/investmenticon.b8244c3a.svg";